import React from 'react';

const ListItem = ({ content }) => {
  return (
    <li className="items-start mb-5" dangerouslySetInnerHTML={{ __html: content }} />
  );
};

export default ListItem;
